import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  color_grey_dark,
  color_grey_light,
  color_white,
} from "../../constants/colors";
import studentColorList from "../../constants/studentColorList";
import NoContentPlaceholder from "../containers/NoContentPlaceholder";
import { ButtonOutlined } from "../controls/Button/ButtonOutlined";
import ArrowIcon from "../icons/ArrowIcon";
import {
  ManRopeRegularDefault,
  ManRopeSemiBoldDefault,
  OnestNormalSmall,
  OnestSemiBoldMed,
} from "../styled/TextComponents";

import Config from "../../Config";
import { useWindowDimensions } from "../../utils";
import { useI18n } from "../../i18n/I18nProvider";

export class LessonInfo {
  constructor(student_id, studentName, time, payedLessons) {
    this.student_id = student_id;
    this.studentName = studentName;
    this.time = time;
    this.payedLessons = payedLessons;
  }
}

const FlexTableLessonRow = ({
  studentName,
  lessonTime,
  payedLessonsCount,
  studentId,
  studentPhoto,
  isLast,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const user = useSelector((state) => state.user);

  const studentColorScheme =
    studentColorList[studentId % studentColorList.length];

  const getLessonsCountColorScheme = () => {
    if (payedLessonsCount > 3)
      return { backgroundColor: "#C8F4C7", color: "#15B01B" };
    else if (payedLessonsCount > 1)
      return { backgroundColor: "#FFE4C4", color: "#FF991F" };
    else if (payedLessonsCount <= 1)
      return { backgroundColor: "#FFCECE", color: "#CF2222" };
    else return { backgroundColor: "#FFCECE", color: "#CF2222" };
  };

  const lessonsColorScheme = getLessonsCountColorScheme();

  const getLessonsCountEnding = () => {
    const lastTwoDigits = payedLessonsCount % 100;
    const lastDigit = payedLessonsCount % 10;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return t("занятий");
    if ([2, 3, 4].includes(lastDigit)) return t("занятия");
    if ([0, 5, 6, 7, 8, 9].includes(lastDigit)) return t("занятий");
    return t("занятие");
  };

  const lessonsCountEnding = getLessonsCountEnding();

  return (
    <div
      style={{
        paddingBottom: screenWidth > 660 ? 15 : 25,
        paddingTop: screenWidth > 660 ? 15 : 25,
        borderBottom: isLast ? "none" : `1px solid ${color_grey_light}`,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
        }}
      >
        <div
          style={
            screenWidth > 660
              ? {
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  gap: 15,
                }
              : {
                  width: 50,
                  display: "flex",
                  flexDirection: "row",
                  gap: 15,
                }
          }
        >
          <div
            style={{
              width: 50,
              height: 50,
              lineHeight: 4,
              borderRadius: "50%",
              color: studentColorScheme.color,
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",

              background: studentPhoto
                ? undefined
                : studentColorScheme.backgroundColor,
              overflow: "hidden",
              position: "relative",
              display: "flex",
            }}
          >
            {studentPhoto && studentPhoto.trim() !== "" ? (
              <img
                src={`${Config.CLOUD_ADDR}/${studentPhoto}`}
                alt={studentName}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                  display: "block",
                }}
              />
            ) : (
              <OnestNormalSmall style={{ marginTop: -4 }}>
                {studentName
                  .split(" ")
                  .map((el) => Array.from(el)[0])
                  .join("")}
              </OnestNormalSmall>
            )}
          </div>
          {screenWidth > 660 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "left",
                justifyContent: "center",
                gap: 5,
              }}
            >
              {studentName.split(" ").map((el, key) => {
                return <OnestNormalSmall key={key}>{el}</OnestNormalSmall>;
              })}
            </div>
          )}
        </div>
        {screenWidth > 660 ? (
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: 5,
            }}
          >
            <ManRopeRegularDefault>
              {" "}
              {moment(lessonTime)?.tz(user.time_zone)?.format("DD.MM.YY")}
            </ManRopeRegularDefault>
            <ManRopeRegularDefault>
              {" "}
              {moment(lessonTime)?.tz(user.time_zone)?.format("HH:mm")}
            </ManRopeRegularDefault>
          </div>
        ) : (
          <div style={{ flex: 1 }}>
            <OnestNormalSmall>{studentName}</OnestNormalSmall>
            <OnestNormalSmall style={{ color: color_grey_light }}>
              {" "}
              {moment(lessonTime)?.tz(user.time_zone)?.format("DD.MM.YY HH:mm")}
            </OnestNormalSmall>
          </div>
        )}
        <div style={{ flex: 1 }}>
          <OnestNormalSmall
            style={{
              width: 100,
              borderRadius: 100,
              backgroundColor: lessonsColorScheme.backgroundColor,
              color: lessonsColorScheme.color,
              textAlign: "center",
              lineHeight: 1.5,
              padding: 8,
            }}
          >{`${payedLessonsCount} ${lessonsCountEnding}`}</OnestNormalSmall>
        </div>
        {screenWidth > 660 && (
          <div
            style={{ flex: 1 }}
            onClick={() => navigate(`/service/students/${studentId}`)}
          >
            <ButtonOutlined
              width={150}
              height={30}
              active={true}
              borderColor={color_grey_dark}
              color={color_grey_dark}
              fontSize={14}
              style={{ borderRadius: 10 }}
            >
              {t("Открыть ученика")} <ArrowIcon fill={color_grey_dark} />
            </ButtonOutlined>
          </div>
        )}
      </div>
      {screenWidth < 661 && (
        <div
          style={{ flex: 1, marginTop: 15 }}
          onClick={() => navigate(`/service/students/${studentId}`)}
        >
          <ButtonOutlined
            width="calc(100%-20px)"
            height={30}
            active={true}
            borderColor={color_grey_dark}
            style={{
              marginTop: 10,
              paddingLeft: 10,
              paddingRight: 10,
              justifyContent: "space-between",
              borderRadius: 10,
            }}
            color={color_grey_dark}
            fontSize={14}
          >
            <OnestNormalSmall>{t("Открыть ученика")}</OnestNormalSmall>
            <ArrowIcon fill={color_grey_dark} />
          </ButtonOutlined>
        </div>
      )}
    </div>
  );
};
const FlexTableHeader = ({ columnNames }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      {columnNames.map((el, key) => {
        let paddingLeft = 0;
        if (key === 1)
          paddingLeft = 15; // Время
        else if (key === 2 || key === 3) paddingLeft = 25; // Оплата и Действия
        return (
          <div key={key} style={{ flex: 1, paddingLeft: paddingLeft }}>
            <ManRopeSemiBoldDefault style={{ color: "#C5C5C5" }}>
              {el}
            </ManRopeSemiBoldDefault>{" "}
          </div>
        );
      })}
    </div>
  );
};
const LessonsTable = ({ lessonsList }) => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  let columnNames = [t("Имя"), t("Время"), t("Оплата"), t("Действия")];
  if (screenWidth > 660) {
    columnNames = [t("Имя"), t("Время"), t("Оплата"), t("Действия")];
  } else {
    columnNames = [t("Имя"), t("Время"), t("Оплата")];
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      {lessonsList.length === 0 ? (
        <NoContentPlaceholder
          noDataText={t("Здесь будут отображаться ваши ближайшие уроки")}
          height={screenHeight - 478 - 40}
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 28,
            flex: 1,
            minHeight: 0,
          }}
        >
          {screenWidth > 660 && <FlexTableHeader columnNames={columnNames} />}
          <div
            style={{
              width: "100%",
              overflowX: "hidden",
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
            }}
          >
            {lessonsList.map((el, key) => {
              return (
                <FlexTableLessonRow
                  key={key}
                  isLast={key === lessonsList.length - 1}
                  studentName={el.studentName}
                  //lessonTime={weekDayToFullWeekName(el.weekday).short + " " + el.time}
                  lessonTime={el.start_time}
                  payedLessonsCount={el.payedLessons}
                  studentId={el.student_id}
                  studentPhoto={el.student_photo}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
export const UpcomingLessonsBlock = ({ lessonsList }) => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: color_white,
        padding: 25,
        borderRadius: 20,
        height: screenHeight - 270,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          marginBottom: 20,
        }}
      >
        <OnestSemiBoldMed>{t("Ближайшие уроки")}</OnestSemiBoldMed>
      </div>
      <LessonsTable lessonsList={lessonsList} />
    </div>
  );
};
